"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.formatNumber = void 0;
/**
 * @param num Number to format
 * @param precision Decimals to use (if present)
 * @param separator Format separator
 */
function formatNumber(num, precision = 0, separator = ' ') {
    if (!isFinite(num)) {
        return num.toString();
    }
    let n = num.toFixed(precision || 0).split('.');
    n[0] = n[0].replace(/\d(?=(\d{3})+$)/g, '$&' + (separator || ','));
    return n.join('.');
}
exports.formatNumber = formatNumber;
//# sourceMappingURL=formatNumber.js.map